import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=fc08b7c8"
import script from "./collapse-item.vue?vue&type=script&lang=js"
export * from "./collapse-item.vue?vue&type=script&lang=js"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=fc08b7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports